import AxiosCustom from "common/components/apiConfig";

export function selectClubmemberStatus(national_id, is_individual) {
  let config = {
    url: "select_request",
  };

  let data = {
    table: "clubmember",
    method_type: "select_clubmember_status",
    token: "3cf61fab-b50a-410f-9d59-3357ee4706fe",
    member_id: "_0zehXYBdxxYGfkX5_wd",
    data: {
      national_id,
      is_individual,
    },
  };

  return AxiosCustom(config, data);
}
